import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-088d551a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "item-icon" }
const _hoisted_3 = { class: "item" }
const _hoisted_4 = { class: "item-measure" }
const _hoisted_5 = { class: "item" }
const _hoisted_6 = { class: "item-title" }
const _hoisted_7 = { class: "item-last-message" }
const _hoisted_8 = { class: "icon" }
const _hoisted_9 = { class: "item" }
const _hoisted_10 = { class: "item-location" }
const _hoisted_11 = { class: "icon" }
const _hoisted_12 = { class: "item-connection" }
const _hoisted_13 = { class: "icon" }
const _hoisted_14 = {
  key: 1,
  class: "item-card"
}
const _hoisted_15 = { class: "item-title" }
const _hoisted_16 = { class: "item-icon" }
const _hoisted_17 = { class: "item-text" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_19 = { class: "item-measure" }
const _hoisted_20 = { class: "item-details" }
const _hoisted_21 = { class: "detail-label" }
const _hoisted_22 = { class: "icon" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Localização", -1))
const _hoisted_24 = { class: "detail-value" }
const _hoisted_25 = { class: "detail-label" }
const _hoisted_26 = { class: "icon" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Conectado à", -1))
const _hoisted_28 = { class: "detail-value" }
const _hoisted_29 = { class: "detail-label" }
const _hoisted_30 = { class: "icon" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Última Mensagem", -1))
const _hoisted_32 = { class: "detail-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SensorIcon = _resolveComponent("SensorIcon")!
  const _component_SensorValue = _resolveComponent("SensorValue")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_SensorLastMessage = _resolveComponent("SensorLastMessage")!
  const _component_SensorConnection = _resolveComponent("SensorConnection")!

  return ((_ctx.gateways && _ctx.gateways.length > 0) || _ctx.isMaster)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.isListMode)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["item-card", { list: _ctx.isListMode }])
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_SensorIcon, {
                  type: _ctx.structure.sensorType || ''
                }, null, 8, ["type"])
              ]),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_SensorValue, { sensor: _ctx.structure }, null, 8, ["sensor"])
                ])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.structure.name), 1),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("span", _hoisted_8, [
                    _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-calendar-days" })
                  ]),
                  _createVNode(_component_SensorLastMessage, { structure: _ctx.structure }, null, 8, ["structure"])
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("span", _hoisted_11, [
                    _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-location-dot" })
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.getFullLocation(_ctx.structure)), 1)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("span", _hoisted_13, [
                    _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-link" })
                  ]),
                  _createVNode(_component_SensorConnection, { sensor: _ctx.structure }, null, 8, ["sensor"])
                ])
              ])
            ], 2))
          : (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_SensorIcon, {
                    type: _ctx.structure.sensorType || ''
                  }, null, 8, ["type"])
                ]),
                _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.structure.name), 1)
              ]),
              _hoisted_18,
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_component_SensorValue, {
                  sensor: _ctx.structure,
                  size: "half-size"
                }, null, 8, ["sensor"])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("span", _hoisted_22, [
                    _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-location-dot" })
                  ]),
                  _hoisted_23
                ]),
                _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.location), 1),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("span", _hoisted_26, [
                    _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-link" })
                  ]),
                  _hoisted_27
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createVNode(_component_SensorConnection, { sensor: _ctx.structure }, null, 8, ["sensor"])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("span", _hoisted_30, [
                    _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-calendar-days" })
                  ]),
                  _hoisted_31
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createVNode(_component_SensorLastMessage, { structure: _ctx.structure }, null, 8, ["structure"])
                ])
              ])
            ]))
      ]))
    : _createCommentVNode("", true)
}